import { render, staticRenderFns } from "./UserInviteForm.vue?vue&type=template&id=265bc77a&scoped=true&"
import script from "./UserInviteForm.vue?vue&type=script&lang=js&"
export * from "./UserInviteForm.vue?vue&type=script&lang=js&"
import style0 from "./UserInviteForm.vue?vue&type=style&index=0&id=265bc77a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "265bc77a",
  null
  
)

export default component.exports